export const FORMAL_VOUCHERS = [
  { value: "E31", label: "Crédito fiscal · E31", electronic: true },
  { value: "E32", label: "Consumo · E32 (sin crédito fiscal)", electronic: true },
];

export const LINE_KINDS = [
  { value: "bien", label: "Bien", hint: "Mercancía, materiales, insumos: no lleva ISR" },
  { value: "servicio", label: "Servicio", hint: "Mano de obra, técnico, chofer, honorarios" },
  { value: "alquiler", label: "Alquiler", hint: "Local, equipo o vehículo alquilado" },
];

export const PAYMENT_METHODS = [
  { value: "efectivo", label: "Efectivo" },
  { value: "credito", label: "Crédito" },
  { value: "transferencia", label: "Transferencia" },
  { value: "cheque", label: "Cheque" },
];

export const localToday = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
};

export const EMPTY_CONCEPT = { name: "", category: "", quantity: 1, price: 0, itbis_applies: false, kind: "servicio" };

export function lineTotals(lines, rate = 18) {
  let subtotal = 0, itbis = 0;
  lines.forEach((l) => {
    const amt = Math.max(Number(l.quantity || 0) * Number(l.price || 0), 0);
    subtotal += amt;
    if (l.itbis_applies) itbis += amt * rate / 100;
  });
  return { subtotal, itbis, total: subtotal + itbis };
}
